const s = {
  name: "Camera",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 34" style="enable-background:new 0 0 40 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,16h14v14H4V16z M6,22v6h10v-6H6z M6,20h10v-2H6V20z"/>
		<path class="st0" d="M23,22.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C21.7,21.7,22.3,22.2,23,22.2z"
			/>
		<path class="st0" d="M24.2,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C23.7,24.8,24.2,25.3,24.2,26z"
			/>
		<path class="st0" d="M36,0c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4H22V5h-7v7h15v7h2v-1.7l8-2.7v16.8l-8-2.7V27h-2v7H0V12h13V3h9V0H36z
			 M24,6h12c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2H24V6z M32,21h-2v4h2V21z M34,18.7v8.6l4,1.3V17.4L34,18.7z M28,14H2v18h26V14z"/>
		<path class="st0" d="M4,10h6V8H4V10z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Camera
};
